<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.jpg" alt="" />
      <img
        src="https://resource.3uplay.com/sys-feed/0a0d8b10.webp"
        alt=""
        class="dressup1"
      />
      <img
        src="https://resource.3uplay.com/sys-feed/612bdabc.webp"
        alt=""
        class="dressup2"
      />
      <button
        type="button"
        class="tab"
        :class="{ active: activeIndex === 1 }"
        @click="checkScoreList(1)"
      >
        週積分
      </button>
      <button
        type="button"
        class="tab2"
        :class="{ active: activeIndex === 2 }"
        @click="checkScoreList(2)"
      >
        累計積分
      </button>
      <div class="week-score">{{ isPlayer ? weekScore : '---' }}</div>
      <div class="all-score">{{ isPlayer ? totalScore : '---' }}</div>
      <div class="top3-box" v-show="activeIndex === 2">
        <div
          v-for="(item, index) of topList.slice(0, 3)"
          :key="item.user_uuid"
          class="item"
          :class="`top${index + 1}`"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <img :src="item.avatar_url" class="head-portrait" />
          <div class="user-name">
            Top{{ index === 0 ? 2 : index === 1 ? 1 : 3
            }}{{ item.user_nickname }}
          </div>
          <div class="score-box">
            <span class="tag">積分</span
            ><span class="score">{{ item.jifen || '--' }}</span>
          </div>
        </div>
      </div>
      <div class="score-board-box" v-show="activeIndex === 2">
        <div
          class="item"
          v-for="(item, index) of list.slice(3, 10)"
          :key="item.user_uuid"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <div class="left">
            <span class="index">Top{{ index + 4 }}</span>
            <img :src="item.avatar_url" alt="排名頭像" class="" />
            <span class="user-name">{{ item.user_nickname }}</span>
          </div>
          <div class="right score-box">
            <span class="tag">積分</span
            ><span class="score">{{ item.jifen || '--' }}</span>
          </div>
        </div>
      </div>
      <div class="top3-box" v-show="activeIndex === 1">
        <div
          v-for="(item, index) of topWeekList.slice(0, 3)"
          :key="item.user_uuid"
          class="item"
          :class="`top${index + 1}`"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <img :src="item.avatar_url" class="head-portrait" />
          <div class="user-name">
            Top{{ index === 0 ? 2 : index === 1 ? 1 : 3
            }}{{ item.user_nickname }}
          </div>
          <div class="score-box">
            <span class="tag">積分</span
            ><span class="score">{{ item.jifen || '--' }}</span>
          </div>
        </div>
      </div>
      <div class="score-board-box" v-show="activeIndex === 1">
        <div
          class="item"
          v-for="(item, index) of weekList.slice(3, 10)"
          :key="item.user_uuid"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <div class="left">
            <span class="index">Top{{ index + 4 }}</span>
            <img :src="item.avatar_url" alt="排名頭像" class="" />
            <span class="user-name">{{ item.user_nickname }}</span>
          </div>
          <div class="right score-box">
            <span class="tag">積分</span
            ><span class="score">{{ item.jifen || '--' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ActivityBox',
  data() {
    return {
      list: [],
      weekList: [],
      myScore: 0,
      activeIndex: 1,
      totalScore: 0,
      weekScore: 0
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 是B端用户
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player';
    },
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    topList() {
      return this.list && this.list.length
        ? [this.list[1], this.list[0], this.list[2]]
        : [];
    },
    topWeekList() {
      return this.weekList && this.weekList.length
        ? [this.weekList[1], this.weekList[0], this.weekList[2]]
        : [];
    }
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getMyscore(val);
        } else {
          this.myScore = 0;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getAllList() {
      try {
        const url = 'https://devops.nicee.app/api/jifen/shiliuqi/voice/all/rank';
        const { data } = await this.$http.get(url);
        this.list = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    async getWeekList() {
      try {
        const url = 'https://devops.nicee.app/api/jifen/shiliuqi/voice/week/rank';
        const { data } = await this.$http.get(url);
        this.weekList = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    async getMyscore(uuid) {
      try {
        const url = `https://devops.nicee.app/api/jifen/shiliuqi/voice/rank/${uuid}`;
        const { data } = await this.$http.get(url);
        if (data) {
          this.totalScore = data.jifen_total || 0;
          this.weekScore = data.jifen_week || 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    },
    checkScoreList(index) {
      this.activeIndex = index;
    }
  },
  created() {
    this.getWeekList();
    this.getAllList();
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #fff7e8;
  overflow: auto;
  text-align: center;
  background-image: url('./images/web-bg.png');
  background-size: 100% 100%;
  .main {
    position: relative;
    display: inline-block;
    width: 750px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .dressup1,
    .dressup2 {
      position: absolute;
      width: dPx(101);
      height: auto;
      top: dPx(819);
    }
    .dressup1 {
      left: dPx(69);
    }
    .dressup2 {
      left: dPx(205);
    }
    .tab,
    .tab2 {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: absolute;
      width: dPx(72);
      height: dPx(28);
      left: dPx(116);
      top: dPx(1870);
      border-radius: 999px;
      font-weight: 500;
      font-size: dPx(12);
      line-height: dPx(17);
      color: #ff1d7b;
      &.active {
        border: 1px solid #ff1d7b;
      }
    }
    .tab2 {
      left: dPx(188);
    }
    .week-score,
    .all-score {
      position: absolute;
      width: dPx(76);
      height: dPx(29);
      top: dPx(1919);
      font-weight: 500;
      font-size: dPx(21);
      line-height: dPx(29);
      text-align: center;
      color: #ff1d7b;
    }
    .week-score {
      left: dPx(92);
    }
    .all-score {
      left: dPx(207);
    }
    .top3-box {
      position: absolute;
      display: flex;
      justify-content: space-between;
      position: absolute;
      width: dPx(291);
      height: dPx(134);
      left: dPx(42);
      top: dPx(1967);

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 24px;
        flex: none;
        color: #ff1d7b;
        width: dPx(94);
        img {
          border-radius: 50%;
          object-fit: cover;
          width: dPx(63);
          height: dPx(63);
          background-color: #d9d9d9;
          object-fit: cover;
          // border: 3px white solid;
        }
        .user-name {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
          font-weight: 400;
          font-size: dPx(12);
          line-height: dPx(24);
          text-align: center;
          color: #ff1d7b;
        }
        .score-box {
          height: dPx(14);
          background: #ffffff;
          border: 1px solid #ff1d7b; /*no*/
          border-radius: dPx(5);
          display: flex;
          align-items: center;
          .score {
            padding: 0 4px;
            font-weight: 400;
            font-size: dPx(12);
          }
          .tag {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: dPx(30);
            height: dPx(14);
            background: #ff1d7b;
            border-radius: dPx(5);
            font-weight: 400;
            font-size: dPx(10);
            line-height: dPx(14);
            text-align: center;
            color: #ffffff;
          }
        }
        &.top1,
        &.top3 {
          margin-top: dPx(32);
        }
      }
    }
    .score-board-box {
      position: absolute;
      top: dPx(2122);
      left: dPx(42);
      // transform: translateX(-50%);
      width: dPx(291);
      overflow: auto;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none;
      }
      .item {
        height: dPx(38);
        background: rgba(255, 29, 123, 0.06);
        border-radius: dPx(5);
        display: flex;
        align-items: center;
        width: 100%;
        font-size: 28px;
        margin-bottom: 2px;
        color: #ff1d7b;
        padding: 0;
        .score-box {
          height: dPx(14);
          background: #ffffff;
          border: 1px solid #ff1d7b; /*no*/
          border-radius: dPx(5);
          display: flex;
          align-items: center;
          .score {
            padding: 0 4px;
            font-weight: 400;
            font-size: dPx(12);
          }
          .tag {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: dPx(30);
            height: dPx(14);
            background: #ff1d7b;
            border-radius: dPx(5);
            font-weight: 400;
            font-size: dPx(10);
            line-height: dPx(14);
            text-align: center;
            color: #ffffff;
          }
        }
        .left,
        .right {
          display: flex;
          align-items: center;
        }
        .right {
          margin-left: 30px;
        }
        .left {
          .index {
            margin-left: dPx(14);
            margin-right: dPx(6);
            width: dPx(37);
            text-align: left;
          }
          img {
            width: dPx(30);
            height: dPx(30);
            background: #d9d9d9;
            border-radius: 50%;
            margin-right: dPx(26);
            object-fit: cover;
          }
          .user-name {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 174px;
          }
        }
        .right {
          img {
            width: 36px;
            margin: 0 0 0 14px;
          }
        }
      }
    }
  }
}
</style>
